import { CircularProgress } from '@material-ui/core'
import React, { FunctionComponent, PropsWithChildren } from 'react'
import 'src/assets/css/components/Spinner.css'
import { ISpinnerProps } from 'src/models/components/ISpinner'

//
// A Spinner that keeps the height of the child content
//
const Spinner: FunctionComponent<ISpinnerProps> = (props: PropsWithChildren<ISpinnerProps>) => {

    const { active, color } = props

    const classes = [
        'spinner',
        ...active ? ['active'] : [],
    ]

    return <div className={classes.join(' ')}>
        <div hidden={!active} className="spinner-loader">
            <CircularProgress color={color ? color : 'primary'} data-testid={props['data-testid']} size='1em' />
        </div>
        <div className="spinner-content">{props.children}</div>
    </div>

}

export default Spinner
